import { saveCareer } from '../../../../../../api/open-account';
import { SelectBox } from '../../../../components/SelectBox';
import { LastNextBtns } from '../../components/LastNextBtns';
import { lastProcess, nextProcess, pState, setFormApi } from '../../store';
import { Form, FormApi, If, onMount } from 'cdui-js';
import { OpenFormItem } from '../../components/OpenFormItem';
import { DiFiInput } from '../../../../../../components/DiFi/DiFiInput';
import i18n from '../../../../../../i18n';
import {
  isEmploymentDetailsLocked,
  sanitizeEmploymentDetailFields,
} from './jobStatusEmployment';
import { isOpenProgressReEdit } from '../../reEditMode';

/** 所属行业 / 职位字典「其他」选项 code */
const DICT_OTHER = 'OTHER';

export const JobStatus = (props) => {
  let formApi: FormApi = null;
  const detailsLocked = () => isEmploymentDetailsLocked(pState.jobStatusForm.employmentStatus);
  const detailsRequired = () => !detailsLocked();
  const hasIndustryOther = () => pState.jobStatusForm.industry === DICT_OTHER;
  const hasPositionOther = () => pState.jobStatusForm.position === DICT_OTHER;

  onMount(() => {
    sanitizeEmploymentDetailFields(pState.jobStatusForm);
  });

  return (
    <div class="padding-x-L margin-y-XL">
      <div class="font-s-L font-bold color-D margin-b-L">
        {i18n.OpenProgress.Info.Job.Title}
        {props.stepText}
      </div>

      <Form
        data={pState.jobStatusForm}
        rules={{}}
        align="top"
        api={(api) => {
          formApi = api;
          setFormApi(api);
        }}
      >
        <OpenFormItem label={i18n.OpenProgress.Info.Job.LabelEducation} field="education" required>
          <SelectBox
            title={i18n.OpenProgress.Info.Job.SelectTitleEducation}
            value={pState.jobStatusForm.education}
            dict="education"
            change={(e) => (pState.jobStatusForm.education = e)}
          />
        </OpenFormItem>

        <OpenFormItem label={i18n.OpenProgress.Info.Job.LabelEmploymentStatus} field="employmentStatus" required>
          <SelectBox
            title={i18n.OpenProgress.Info.Job.LabelEmploymentStatus}
            value={pState.jobStatusForm.employmentStatus}
            dict="employmentStatus"
            change={(e) => {
              pState.jobStatusForm.employmentStatus = e;
              sanitizeEmploymentDetailFields(pState.jobStatusForm);
            }}
          />
        </OpenFormItem>

        <OpenFormItem
          label={i18n.OpenProgress.Info.Job.LabelCompanyName}
          field="companyName"
          required={detailsRequired()}
        >
          <div>
            <DiFiInput
              shellClass="f-input-2"
              inputKind="text"
              maxLength={80}
              disabled={detailsLocked()}
              placeholder={i18n.OpenProgress.Common.PlaceholderEnter}
              value={pState.jobStatusForm.companyName}
              onUpdateValue={(v) => (pState.jobStatusForm.companyName = v)}
            />
          </div>
        </OpenFormItem>

        <OpenFormItem
          label={i18n.OpenProgress.Info.Job.LabelIndustry}
          field="industry"
          required={detailsRequired()}
        >
          <SelectBox
            title={i18n.OpenProgress.Info.Job.SelectTitleIndustry}
            value={pState.jobStatusForm.industry}
            dict="industry"
            disabled={detailsLocked()}
            change={(e) => {
              pState.jobStatusForm.industry = e;
              if (e !== DICT_OTHER) {
                pState.jobStatusForm.industryOther = '';
              }
            }}
          />
        </OpenFormItem>

        <If when={hasIndustryOther()}>
          <OpenFormItem label="" field="industryOther" required={detailsRequired()}>
            <DiFiInput
              type="textarea"
              rows={3}
              shellClass="f-input-2"
              maxLength={80}
              disabled={detailsLocked()}
              placeholder={i18n.OpenProgress.Info.Job.IndustryOtherPlaceholder}
              value={pState.jobStatusForm.industryOther}
              onUpdateValue={(v) => (pState.jobStatusForm.industryOther = v)}
            />
          </OpenFormItem>
        </If>

        <OpenFormItem
          label={i18n.OpenProgress.Info.Job.LabelPosition}
          field="position"
          required={detailsRequired()}
        >
          <SelectBox
            title={i18n.OpenProgress.Info.Job.LabelPosition}
            value={pState.jobStatusForm.position}
            dict="position"
            disabled={detailsLocked()}
            change={(e) => {
              pState.jobStatusForm.position = e;
              if (e !== DICT_OTHER) {
                pState.jobStatusForm.positionOther = '';
              }
            }}
          />
        </OpenFormItem>

        <If when={hasPositionOther()}>
          <OpenFormItem label="" field="positionOther" required={detailsRequired()}>
            <DiFiInput
              type="textarea"
              rows={3}
              shellClass="f-input-2"
              maxLength={80}
              disabled={detailsLocked()}
              placeholder={i18n.OpenProgress.Info.Job.PositionOtherPlaceholder}
              value={pState.jobStatusForm.positionOther}
              onUpdateValue={(v) => (pState.jobStatusForm.positionOther = v)}
            />
          </OpenFormItem>
        </If>

        <OpenFormItem label={i18n.OpenProgress.Info.Job.LabelCompanyAddress} field="companyAddress">
          <div>
            <DiFiInput
              shellClass="f-input-2"
              inputKind="text"
              maxLength={80}
              disabled={detailsLocked()}
              placeholder={i18n.OpenProgress.Common.PlaceholderEnter}
              value={pState.jobStatusForm.companyAddress}
              onUpdateValue={(v) => (pState.jobStatusForm.companyAddress = v)}
            />
          </div>
        </OpenFormItem>

        <OpenFormItem
          label={i18n.OpenProgress.Info.Job.LabelEmploymentYears}
          field="employmentYears"
          required={detailsRequired()}
        >
          <SelectBox
            title={i18n.OpenProgress.Info.Job.LabelEmploymentYears}
            value={pState.jobStatusForm.employmentYears}
            dict="employmentYear"
            disabled={detailsLocked()}
            change={(e) => (pState.jobStatusForm.employmentYears = e)}
          />
        </OpenFormItem>

        <OpenFormItem label={i18n.OpenProgress.Info.Job.LabelCompanyPhone} field="companyPhone">
          <div>
            <DiFiInput
              shellClass="f-input-2"
              type="tel"
              inputKind="tel"
              maxLength={50}
              disabled={detailsLocked()}
              value={pState.jobStatusForm.companyPhone}
              onUpdateValue={(v) => {
                pState.jobStatusForm.companyPhone = v;
              }}
              placeholder={i18n.OpenProgress.Common.PlaceholderEnter}
            />
          </div>
        </OpenFormItem>
      </Form>

      <If when={!isOpenProgressReEdit(props)}>
        <LastNextBtns
          last={() => {
            lastProcess();
          }}
          next={async () => {
            const valid = await formApi.validate();
            if (!valid) return;
            const data = { ...pState.jobStatusForm };
            sanitizeEmploymentDetailFields(data);
            if (data.industry !== DICT_OTHER) {
              data.industryOther = '';
            }
            if (data.position !== DICT_OTHER) {
              data.positionOther = '';
            }
            await saveCareer({ ...data, progress: 5 });
            nextProcess();
          }}
        />
      </If>
    </div>
  );
};
